<template>
  <NsiCard :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :listName="listName" />
</template>

<script>
  import NsiCard from '../components/NsiCard.vue';

  export default {
    name: 'NsiMpkStatusCard',
    components: {
      NsiCard,
    },
    data() {
      return {
        pageTitle: 'Карточка статус МПК',
        apiRoute: 'nsiMpkStatus',
        cardName: 'NsiMpkStatusCard',
        listName: 'NsiMpkStatuses',
      };
    },
    created() {},
    methods: {},
  };
</script>
